import { request } from './client';
import type { WheelSpinsFilters, WheelSpinsPage, WheelSpinsSummary } from './types';

export const WHEEL_SPINS_PAGE_SIZE = 50;

// Empty filters are not sent; the statuses travel as one comma-separated `status`.
function filterParams({ statuses, ...filters }: WheelSpinsFilters): URLSearchParams {
  const params = new URLSearchParams();
  Object.entries({ ...filters, status: statuses.join(',') }).forEach(([name, value]) => {
    if (value.trim()) params.set(name, value.trim());
  });
  return params;
}

export const fetchWheelSpins = (
  key: string,
  filters: WheelSpinsFilters,
  cursor: string | null,
  signal?: AbortSignal,
) => {
  const params = filterParams(filters);
  if (cursor) params.set('cursor', cursor);
  params.set('limit', String(WHEEL_SPINS_PAGE_SIZE));
  return request<WheelSpinsPage>(`/api/daily-wheel/admin/spins?${params.toString()}`, { key, signal });
};

export const fetchWheelSpinsSummary = (key: string, filters: WheelSpinsFilters, signal?: AbortSignal) =>
  request<WheelSpinsSummary>(`/api/daily-wheel/admin/spins/summary?${filterParams(filters).toString()}`, {
    key,
    signal,
  });
